import React, {useEffect, useState} from 'react';
import {
    IonPage,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton, useIonAlert, IonAlert
} from '@ionic/react';
import appLogo from '../theme/images/logo-big.png';
import { useHistory } from 'react-router';
import {actionToSendForgotPasswordOtp, actionToVerifyResetPasswordOtpAndSavePass} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";

const ForgotPassword = ({renderHeaderPage}) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [showResetPasswordPopup, setShowResetPasswordPopup] = useState(false);
    const history = useHistory();
    const [presentAlert] = useIonAlert();
    const {setSignupSigninError,setOtpValidationError,otpValidationError,signupSigninError,userOtpDetails} = useStore();

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleSubmit = () => {
        if (!email.trim()) {
            setError('Email is required');
            return;
        }

        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }
        setError('');

        actionToSendForgotPasswordOtp({email});
    };

    const showOtpAlert = () => {
        setShowResetPasswordPopup(true);
    };

    const goToPage = (page)=>{
        history.replace(page);
    }

    const handleResetPassword = (payload)=>{
        actionToVerifyResetPasswordOtpAndSavePass(payload,history);
        return false;
    }

    useEffect(()=>{
        if(otpValidationError){
            presentAlert({
                header: 'OTP Verification fail',
                message: 'You have entered wrong otp.',
                buttons: [{
                    text: 'Ok',
                    handler: ()=>{
                        setOtpValidationError(false);
                    },
                }],
            });
        }
    },[otpValidationError])

    useEffect(()=>{
        if (signupSigninError?.error && signupSigninError?.message){
            presentAlert({
                header: 'Registration Failed!',
                message: signupSigninError?.message,
                buttons: [{
                    text: 'Ok'
                }],
            });
        }
    },[signupSigninError])

    useEffect(()=>{
        if (!userOtpDetails?.loading && userOtpDetails?.success){
            showOtpAlert();
        }
    },[userOtpDetails])

    useEffect(()=>{
        setShowResetPasswordPopup(false);
        setEmail('');
        setSignupSigninError({});
    },[])

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="login-content">
                <IonGrid className="login-grid">
                    <IonRow>
                        <IonCol size="12" className="ion-text-center">
                            <img
                                src={appLogo}
                                alt="CA World"
                                className="login-logo"
                            />
                        </IonCol>

                        <IonCol size="12">
                            <div className="login-group">
                                <label className="login-label">Enter your Email Address</label>
                                <input
                                    type="email"
                                    className="login-input"
                                    placeholder="Email Address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {error && <p className={"danger_error_text"} color="danger">{error}</p>}
                            </div>
                        </IonCol>

                        <IonCol size="12">
                            <IonButton expand="block" className="login-button" onClick={handleSubmit}>
                                Send OTP
                            </IonButton>
                        </IonCol>
                        <IonCol size="12" className="ion-text-center">
                            <p className="login-link-text or-sec">OR</p>
                            <p className="login-link-text" onClick={() => history.replace('/login')}>
                                Remembered your password? <a onClick={() => goToPage('/login')}
                                                             className="login-link">Login</a>
                            </p>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>

            <IonAlert
                isOpen={showResetPasswordPopup}
                onDidDismiss={() => setShowResetPasswordPopup(false)}
                header="Reset Password"
                inputs={[
                    {
                        name: 'otp',
                        type: 'number',
                        placeholder: 'Enter OTP',
                    },
                    {
                        name: 'password',
                        type: 'password',
                        placeholder: 'New Password (min 8 chars)',
                    },
                    {
                        name: 'confirmPassword',
                        type: 'password',
                        placeholder: 'Confirm Password',
                    },
                ]}
                buttons={[
                    {
                        text: 'Cancel',
                        role: 'cancel',
                    },
                    {
                        text: 'Submit',
                        handler: (data) => {
                            const { otp, password, confirmPassword } = data;

                            // 🔹 Validations with Ionic presentAlert
                            if (!otp) {
                                presentAlert({
                                    header: 'Validation Error',
                                    message: 'Please enter OTP.',
                                    buttons: ['OK'],
                                });
                                return false;
                            }
                            if (!password || password.length < 8) {
                                presentAlert({
                                    header: 'Validation Error',
                                    message: 'Password must be at least 8 characters.',
                                    buttons: ['OK'],
                                });
                                return false;
                            }
                            if (password !== confirmPassword) {
                                presentAlert({
                                    header: 'Validation Error',
                                    message: 'Passwords do not match.',
                                    buttons: ['OK'],
                                });
                                return false;
                            }

                            // ✅ All good → call API
                            handleResetPassword({ email,otp, password });
                            return true; // closes alert
                        },
                    },
                ]}
            />
        </IonPage>
    );
};

export default ForgotPassword;
